export default __webpack_public_path__ + "static/media/ZaySneaker.b8688318.jpg";